export const California = 2
export const Washington = 3
export const Oregon = 4
export const Nevada = 5
export const Arizona = 6
export const Utah = 7
export const Idaho = 8
export const Colarado = 9
export const Montana = 10
export const Wyoming = 11
export const North_Dakota = 12
export const South_Dakota = 13
export const Nebraska = 14
export const Kansas = 15
export const New_Mexico = 16
export const Texas = 17
export const Oklahoma = 18
export const Minnesota = 19
export const Iowa = 20
export const Mississippi = 21
export const Louisiana = 22
export const Alabama = 23
export const Kentucky = 24
export const South_Carolina = 25
export const Georgia = 26
export const Missouri = 27
export const Arkansas = 28
export const Tennessee = 29
export const Massachusets = 30
export const Washington_DC = 31
export const North_Carolina = 32
export const Wisconsin = 33
export const Connecticut = 34
export const Illinois = 35
export const Indiana = 36
export const Ohio = 37
export const West_Virginia = 38
export const Virginia = 39
export const Maryland = 40
export const Delaware = 41
export const New_Jersey = 42
export const Pennsylvania = 43
export const New_York = 44
export const Rhode_Island = 45
export const Maine = 46
export const Vermont = 47
export const Michigan = 48
export const New_Hampshire = 49
export const Florida = 50
export const Alaska = 51
export const Hawaii = 52

let americaStates = new Map()
americaStates.set(California, 'California')
americaStates.set(Washington, 'Washington')
americaStates.set(Oregon, 'Oregon')
americaStates.set(Nevada, 'Nevada')
americaStates.set(Arizona, 'Arizona')
americaStates.set(Utah, 'Utah')
americaStates.set(Idaho, 'Idaho')
americaStates.set(Colarado, 'Colarado')
americaStates.set(Montana, 'Montana')
americaStates.set(Wyoming, 'Wyoming')
americaStates.set(North_Dakota, 'North Dakota')
americaStates.set(South_Dakota, 'South Dakota')
americaStates.set(Nebraska, 'Nebraska')
americaStates.set(Kansas, 'Kansas')
americaStates.set(New_Mexico, 'New Mexico')
americaStates.set(Texas, 'Texas')
americaStates.set(Oklahoma, 'Oklahoma')
americaStates.set(Minnesota, 'Minnesota')
americaStates.set(Iowa, 'Iowa')
americaStates.set(Mississippi, 'Mississippi')
americaStates.set(Louisiana, 'Louisiana')
americaStates.set(Alabama, 'Alabama')
americaStates.set(Kentucky, 'Kentucky')
americaStates.set(South_Carolina, 'South Carolina')
americaStates.set(Georgia, 'Georgia')
americaStates.set(Missouri, 'Missouri')
americaStates.set(Arkansas, 'Arkansas')
americaStates.set(Tennessee, 'Tennessee')
americaStates.set(Massachusets, 'Massachusets')
americaStates.set(Washington_DC, 'Washington DC')
americaStates.set(North_Carolina, 'North Carolina')
americaStates.set(Wisconsin, 'Wisconsin')
americaStates.set(Connecticut, 'Connecticut')
americaStates.set(Illinois, 'Illinois')
americaStates.set(Indiana, 'Indiana')
americaStates.set(Ohio, 'Ohio')
americaStates.set(West_Virginia, 'West Virginia')
americaStates.set(Virginia, 'Virginia')
americaStates.set(Maryland, 'Maryland')
americaStates.set(Delaware, 'Delaware')
americaStates.set(New_Jersey, 'New Jersey')
americaStates.set(Pennsylvania, 'Pennsylvania')
americaStates.set(New_York, 'New York')
americaStates.set(Rhode_Island, 'Rhode Island')
americaStates.set(Maine, 'Maine')
americaStates.set(Vermont, 'Vermont')
americaStates.set(Michigan, 'Michigan')
americaStates.set(New_Hampshire, 'New Hampshire')
americaStates.set(Florida, 'Florida')
americaStates.set(Alaska, 'Alaska')
americaStates.set(Hawaii, 'Hawaii')

export const getAmericaStateName = (id) => {
  return americaStates.get(id)
}
